export const shortCategories = (categories) => {
  return categories.map((category) => `${category.name.substring(0, 1)}`).join(', ');
};